module.exports = {"G":{"x":50,"y":89},"DG":{"x":15,"y":70},"DC1":{"x":38,"y":70},"DC2":{"x":61,"y":70},"DD":{"x":85,"y":70},"MG":{"x":15,"y":48},"MC":{"x":38,"y":48},"MD":{"x":61,"y":48},"AG":{"x":85,"y":48},"BU":{"x":35,"y":26},"AD":{"x":65,"y":26}}


//////////////////
// WEBPACK FOOTER
// ./src/tactics/4-4-2.json
// module id = 27
// module chunks = 0